import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

// these are excluded from production
export const mspRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.medicalCenterManagement.route,
      lazy: () => import("@pages/panelPages/medicalCenterManagement/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.medicalCenterManagement",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.medicalCenterManagementCreate.route,
      lazy: () => import("@pages/panelPages/medicalCenterManagement/form/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.mspCreate", [], "create", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.medicalCenterManagementEdit.route,
      lazy: () => import("@pages/panelPages/medicalCenterManagement/form/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.mspEdit", [], "edit", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.medicalCenterManagementView.route,
      lazy: () => import("@pages/panelPages/medicalCenterManagement/form/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.mspView", [], "view", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.assignMspList.route,
      lazy: () =>
        import(
          "@pages/panelPages/assignMedicalCenter/assignMedicalCenterTable"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.assignMspList", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.assignMspCreate.route,
      lazy: () =>
        import("@pages/panelPages/assignMedicalCenter/assignMedicalCenterForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.assignMsp", [], "create", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.assignMspAdd.route,
      lazy: () =>
        import("@pages/panelPages/assignMedicalCenter/assignMedicalCenterForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.assignMsp", [], "edit", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.viewAssignedMsp.route,
      lazy: () =>
        import("@pages/panelPages/assignMedicalCenter/assignMedicalCenterForm"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.viewDoctors", [], "view", "inner");
        return {};
      },
    },
    permissions: ["super-admin"],
  },
  {
    route: {
      path: path.prescriptionList.route,
      lazy: () => import("@pages/panelPages/mspList/table/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.prescriptionList", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-drug"],
  },
  {
    route: {
      path: path.prescriptionView.route,
      lazy: () => import("@pages/panelPages/mspList/view/prescription/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.show_prescription",
            [],
            "index",
            "inner",
          );
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-drug"],
  },
  {
    route: {
      path: path.experimentList.route,
      lazy: () => import("@pages/panelPages/mspList/table/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.experimentsList", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-lab"],
  },
  {
    route: {
      path: path.experimentsView.route,
      lazy: () => import("@pages/panelPages/mspList/view/experiments/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.show_prescription",
            [],
            "index",
            "inner",
          );
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-lab"],
  },
  {
    route: {
      path: path.imagesList.route,
      lazy: () => import("@pages/panelPages/mspList/table/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.imagesList", [], "index", "main");
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-image"],
  },
  {
    route: {
      path: path.imagesView.route,
      lazy: () => import("@pages/panelPages/mspList/view/images/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.show_prescription",
            [],
            "index",
            "inner",
          );
        return {};
      },
    },
    permissions: ["super-admin", "medical-service-provider-image"],
  },
  {
    route: {
      path: path.mspDoctors.route,
      lazy: () => import("@pages/panelPages/mspDoctors/table/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.myDoctors", [], "index", "main");
        return {};
      },
    },
    permissions: [
      "super-admin",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
  {
    route: {
      path: path.mspReports.route,
      lazy: () => import("@pages/panelPages/mspReports/table/page"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.prescriptionReports",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: [
      "super-admin",
      "medical-service-provider-lab",
      "medical-service-provider-drug",
      "medical-service-provider-image",
    ],
  },
];
